import { useNavigate } from 'react-router-dom';
import { useCompare } from '@/context/CompareContext';
import { X, ArrowRight, Layers } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function CompareBar() {
  const { items, removeFromCompare, clearCompare } = useCompare();
  const navigate = useNavigate();

  if (items.length === 0) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 border-t border-slate-200 bg-white/95 backdrop-blur-xl shadow-[0_-4px_30px_rgba(0,0,0,0.08)]" data-testid="compare-bar">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-3">
        <div className="flex items-center justify-between gap-4">
          {/* Left: selected items */}
          <div className="flex items-center gap-3 flex-1 min-w-0 overflow-x-auto">
            <div className="flex items-center gap-1.5 flex-shrink-0">
              <Layers className="h-4 w-4 text-teal-500" />
              <span className="text-[13px] font-semibold text-slate-700" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Compare
              </span>
              <span className="text-[11px] text-slate-400 font-medium">
                ({items.length}/3)
              </span>
            </div>

            <div className="flex items-center gap-2">
              {items.map(opp => (
                <div
                  key={opp.opportunity_id}
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-slate-50 border border-slate-200 rounded-lg text-[12px] font-medium text-slate-700 flex-shrink-0 max-w-[180px]"
                  data-testid={`compare-item-${opp.opportunity_id}`}
                >
                  <span className="truncate">{opp.name}</span>
                  <button
                    onClick={() => removeFromCompare(opp.opportunity_id)}
                    className="text-slate-400 hover:text-red-500 transition-colors flex-shrink-0"
                    data-testid={`compare-remove-${opp.opportunity_id}`}
                    aria-label={`Remove ${opp.name} from compare`}
                  >
                    <X className="h-3 w-3" />
                  </button>
                </div>
              ))}
            </div>
          </div>

          {/* Right: actions */}
          <div className="flex items-center gap-2 flex-shrink-0">
            <Button
              variant="ghost"
              size="sm"
              onClick={clearCompare}
              className="text-slate-400 hover:text-red-500 text-[12px] h-8"
              data-testid="compare-clear-all"
            >
              Clear
            </Button>
            <Button
              onClick={() => navigate('/compare')}
              disabled={items.length < 2}
              size="sm"
              className="bg-teal-500 hover:bg-teal-600 text-white text-[12px] font-semibold h-8 px-4 rounded-lg disabled:opacity-40"
              data-testid="compare-now-button"
            >
              Compare Now
              <ArrowRight className="h-3.5 w-3.5 ml-1" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
